import { put, all, fork } from 'redux-saga/effects'

// this functions similar to a reducer in that it receives all actions
// dispatched in the system but only actions on certain ones. For those
// certain actions, it knows they will consist of data from a group of
// individual api calls lumped together in a predefined way. As a result
// it is able to split them apart and redispatch them as the individual parts
// so that the existing reducers can handle them individually

// this is part of what splits the globalAppConfig data blob into what appear to be
// individual api calls the normal STORE_WHATEVER reducer cases can handle.
export default function* internalApiParser(action) {
  if (
    action.type.match(/^STORE_(PATIENT_){0,1}XTRACT\/(?!CLOUD_ADMIN).*READ_ALL/) &&
    action.result
    ) {
    yield fork(function* () {
      yield all(
        // map creates an array of puts that looks like:
        // [put(action), put(action)]
        // that array is then executed in parallel by yield all
        Object.keys(action.result).map(resource => {
          // kind of a hack...sometimes the result is passed to handleCRUD
          // which looks at the ids property... this only sets it when a
          // patient object is queried...but I think that is the only time
          // its used right now so thats ok.
          const ids = action.result['patient_read']
            ? { patient_id: action.result['patient_read'].patient_id }
            : null

          return put({
            type: `STORE_${resource.toUpperCase()}`,
            result: action.result[resource],
            ids,
            server_time: action.server_time
          })
        })
      )
    })
  }
}
